import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './ui/Accordion';
export function FAQ() {
  const faqs = [{
    question: '¿Cómo recibo el material?',
    answer: 'El acceso es digital e inmediato. Una vez realizada la compra, recibís los archivos en formato PDF para descargar y usar desde celular, tablet o computadora.'
  }, {
    question: '¿Para qué año de la carrera está pensado?',
    answer: 'Para estudiantes desde años intermedios en adelante (prácticas, internado) y enfermeros/as junior que quieran ordenar sus conocimientos clínicos.'
  }, {
    question: '¿Qué lo diferencia de los apuntes de la facultad?',
    answer: 'No es teoría dispersa. Es un sistema clínico organizado y orientado a la práctica real: valoración, procedimientos, farmacología y casos clínicos.'
  }, {
    question: '¿Incluye farmacología y cálculos?',
    answer: 'Sí. El Tomo 5 está dedicado a farmacología aplicada y cálculos, y además tenés el Bono 4 como guía rápida de apoyo.'
  }, {
    question: '¿Los casos clínicos están resueltos paso a paso?',
    answer: 'Sí. El Tomo 6 incluye casos clínicos resueltos con análisis, priorización, errores frecuentes y aprendizaje clave.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí, tenés 7 días de garantía. Si no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-white" data-id="element-73">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="text-center mb-8 md:mb-10" data-id="element-75">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-76">
            Preguntas frecuentes
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-3 leading-[1.05] uppercase" data-id="element-77">
            Lo que más nos{' '}
            <span className="accent-italic normal-case" data-id="element-78">preguntan</span>
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-3" data-id="element-79">
          {faqs.map((faq, idx) => <Accordion key={idx} title={faq.question} data-id="element-80">
              <p className="text-sm md:text-base text-clinical-ink leading-relaxed" data-id="element-81">
                {faq.answer}
              </p>
            </Accordion>)}
        </motion.div>
      </div>
    </section>;
}